import React from 'react';

import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import ConfirmationModal from '@/components/popups/ConfirmationModal';

import { trainingModeDispatchAtom } from '@/atoms/trainingMode';

interface EntgerTrainTogetherProps {
  onEnterTrainingMode: () => void;
  trainingModeModalIsOpen: boolean;
}

const EnterTrainTogether: React.FC<EntgerTrainTogetherProps> = ({
  onEnterTrainingMode,
  trainingModeModalIsOpen,
}) => {
  const { t } = useTranslation();
  const sendTrainingModeAction = useSetAtom(trainingModeDispatchAtom);

  return (
    <ConfirmationModal
      bodyText={t('TrainingPlans.trainTogether.enterModalBody')}
      headerText={t('TrainingPlans.trainTogether.enterModalHeader')}
      isOpen={trainingModeModalIsOpen}
      onClose={() => sendTrainingModeAction('hideTrainingMode')}
      primaryButtonColor={'secondary'}
      primaryButtonHandler={onEnterTrainingMode}
      primaryButtonText={t('Button.iUnderstand')}
      secondaryButtonHandler={() => sendTrainingModeAction('hideTrainingMode')}
      secondaryButtonText={t('Button.cancel')}
    />
  );
};

export default EnterTrainTogether;
